<template>
  <section
    class="component-df54bc0c"
    resmed-component-name="info_50/50_icon-line_text_image_2cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-5 offset-md-1">
            <figure class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                v-bind:src="`//players.brightcove.net/2750693505001/${acf.player}_default/index.html?videoId=${acf.id}`"
                frameborder="0"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
                allow="encrypted-media"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  left: 0px;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </figure>
          </div>
          <div class="col-md-6">
            <div class="wrapper pt-6 pt-md-0 pl-md-4">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <h2>{{ acf.headline }}</h2>
              <div class="mb-4" v-html="acf.content"></div>

              <a
                v-if="acf.cta[0]"
                v-bind:target="acf.cta[0].cta.target"
                v-bind:href="acf.cta[0].cta.href"
                class="btn cta-pill hallow-white icon right-arrow mr-3"
                >{{ acf.cta[0].cta.text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:target="acf.cta[1].cta.target"
                v-bind:href="acf.cta[1].cta.href"
                class="btn cta-plain text-white icon right-arrow"
                >{{ acf.cta[1].cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-df54bc0c", // info_50/50_icon-line_text_image_2cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-df54bc0c {
  padding: 7rem 0;
  background-size: cover;
  background-repeat: no-repeat;
}

.component {
  &.text-color-white {
    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    position: relative;
    margin-bottom: 1rem;

    @extend %eyebrow-left;
  }

  figure {
    border-radius: 6px;
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    overflow: hidden;
  }
}
</style>